import { Entity, EntityLink } from '@backstage/catalog-model';

const DOCS_TITLE = /confluence|docs|documentation|wiki|runbook/i;
const DOCS_HOST = /atlassian\.net$/i;

function isDocsLink(link: EntityLink): boolean {
  if (DOCS_TITLE.test(link.title ?? '')) {
    return true;
  }
  try {
    const url = new URL(link.url);
    return DOCS_HOST.test(url.hostname) && url.pathname.startsWith('/wiki');
  } catch {
    return false;
  }
}

// Returns the first link that looks like documentation.
export function findDocsLink(entity: Entity): EntityLink | undefined {
  return entity.metadata.links?.find(isDocsLink);
}
